export default __webpack_public_path__ + "static/media/chirurgie.baf0f6b3.png";